import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Curso Expert em Henna</h3>
            <p>Transforme sua carreira na area da beleza</p>
          </div>
          
          <div className="footer-links">
            <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer">
              Inscreva-se
            </a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>Curso Expert em Henna - Leticia Venancio. Todos os direitos reservados.</p>
          <p className="footer-disclaimer">
            Este produto e comercializado com apoio da Kiwify. A plataforma nao faz controle editorial previo dos produtos comercializados, 
            tao pouco avalia a tecnicidade e experiencia daqueles que os produzem.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
